module.exports = __webpack_public_path__ + "static/kubernetes3x-77554044289e8ec313e200130e9a968b.png";